import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseEventTokenCreated } from 'entities/Auth'
import { ConversationRoutes } from 'entities/ExportRouters'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type RegisterStore } from 'pages/register/ui/Register'

export const useEventTokenCreated = (store: RegisterStore) => {
  const { websocket, authStore } = useEntitiesContext()
  const handler = async (data: IResponseEventTokenCreated) => {
    if (store) {
      await store.gtmStore.logNewAccount(data.token, store)
      store.setLoading(false)
    }

    const searchParams = new URLSearchParams(window.location.search)
    if (searchParams.get('c')) {
      searchParams.delete('c')

      const authRedirectUrl = `/${ConversationRoutes.root}?${searchParams}`
      authStore.setAuthRedirectUrl(authRedirectUrl)
    }

    authStore.setSuccessAuthToken(data.token.access_token)
  }

  useEffect(() => {
    if (!store.profileChanelSubscribed) return

    const listener = websocket.on(WebsocketEvent.TokenCreated, handler)

    return () => {
      listener()
    }
  }, [store.profileChanelSubscribed])
}
